import React from 'react'
import {
    AnalyticsTabs,FlexyRow,FlexyRowJustify
  } from './../../home/home.style';
import { formatAmount } from '../../../../../widget/util';
// import Cookies from 'js-cookie';


function DuesAnalyticsWidget(props) {

const details = props.analyticsTabs

  return (
    <div className='row'>
        <FlexyRow>
          <AnalyticsTabs>
            <h5>DUES AMOUNT</h5>
            <FlexyRowJustify>
              <h6 className='value'>N{
                formatAmount(parseFloat(details.due.defaultAmount))
              }</h6>
              <h6>
                {/* <i className='material-icons'>content_copy</i> */}
              </h6>
            </FlexyRowJustify>   
          </AnalyticsTabs>
         
          <AnalyticsTabs>
            <h5>dues pAID</h5>
            <FlexyRowJustify>
              <h6 className='value'>N{
              
              formatAmount(parseFloat(details.paidBillsAmount))
              }</h6>
              <h6 style={{
                color:"#4F46E5"
              }}>
                {/* IN ESTATE */}
              </h6>
            </FlexyRowJustify>   
          </AnalyticsTabs>

          <AnalyticsTabs>
            <h5>dues  oustanding</h5>
            <FlexyRowJustify>
              <h6 className='value'>N{
              
              formatAmount(parseFloat(details.pendingBillsAmount))
              
              }</h6>
              <h6 style={{
                color:"#EF4444"
              }}>
              {/* OCCUPIED */}
              </h6>
            </FlexyRowJustify>   
          </AnalyticsTabs>

          <AnalyticsTabs>
            <h5>DUES ASSIGNED TO</h5>
            <FlexyRowJustify>
              <h6 className='value'>
                {details.appliesToAllProperties?'All Properties':`${details.due.properties.length} `}
              </h6>
              <h6 style={{
                color:"#22C55E"
              }}>
              {/* AVAILABLE */}
              </h6>
            </FlexyRowJustify>   
          </AnalyticsTabs>

         
        </FlexyRow>
      </div>
  )
}

export default DuesAnalyticsWidget